import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboardPencilLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 48,
	viewBox: "0 0 64 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3846_330)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 4.5,
				width: 55,
				height: 43,
				rx: 3.5,
				stroke: "black",
				strokeOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36 8L35.9893 8.2041C35.8938 9.14565 35.1457 9.8938 34.2041 9.98926L34 10H21L20.7959 9.98926C19.8543 9.8938 19.1062 9.14565 19.0107 8.2041L19 8V5H20V8C20 8.55228 20.4477 9 21 9H34C34.5523 9 35 8.55228 35 8V5H36V8Z",
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34 2C34.5523 2 35 2.44772 35 3L34.8975 3.00488C34.3933 3.05621 34 3.48232 34 4H21C21 3.48232 20.6067 3.05621 20.1025 3.00488L20 3C20 2.44772 20.4477 2 21 2H34Z",
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27 1C27 1.55228 27.4477 2 28 2H26C26 1.44772 26.4477 1 27 1ZM29.1025 1.00488C29.6067 1.05621 30 1.48232 30 2H28C28.5523 2 29 1.55228 29 1L29.1025 1.00488Z",
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 28,
				cy: .75,
				r: .75,
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 3C20.5523 3 21 3.44772 21 4H18C18 3.44772 18.4477 3 19 3H20ZM36 3C36.5523 3 37 3.44772 37 4H34C34 3.44772 34.4477 3 35 3H36Z",
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 4,
				cy: 13,
				r: 1,
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 4,
				cy: 34,
				r: 1,
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 4,
				cy: 18,
				r: 1,
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 4,
				cy: 39,
				r: 1,
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 15H51.5",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 19H51.5",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 23H51.5",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 33H51.5",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 41H51.5",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 37H51.5",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 6V45.5",
				stroke: "#FF2411",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 17.5895C12.5 16.5895 12 18.5895 15 17.5895C18 16.5895 18 14.5893 20 16.0894C22 17.5895 15.5 19.0896 18 17.5895C20.5 16.0894 21 16.0894 22.5 16.5894C24 17.0894 28 17.5894 33.5 17.0894",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5 35.0001C13 34.0001 19 36.0001 16 36.0001C13 36.0001 15.5 34.0001 17 34.0001C18.5 34.0001 21.5 36.0001 23.5 35.5001C25.5 35.0001 29 33.0001 27.5 34.5001C26 36.0001 25 36.0001 27.5 35.5001C30 35.0001 31 34.0001 33.5 34.5001",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_3846_330)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M63.4907 47.164C63.4099 47.6018 63.0432 47.9471 62.5785 47.9796C62.1139 48.0121 61.7027 47.7211 61.5618 47.2988L63.4907 47.164ZM63.5064 46.9123C63.5075 46.9293 63.5076 46.9462 63.5079 46.963L61.5167 47.1023C61.5147 47.0856 61.5124 47.0688 61.5112 47.0518L61.4833 46.6523L63.4784 46.5128L63.5064 46.9123ZM63.4645 46.3141L61.4694 46.4536L61.4415 46.0542L63.4366 45.9147L63.4645 46.3141Z",
						fill: "black",
						fillOpacity: .24
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M59.9976 11.0696L61.2044 13.9926L59.2093 14.1321L59.9976 11.0696Z",
						fill: "black",
						fillOpacity: .16
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M60.3995 12.0439L59.7351 12.0903L59.9976 11.0695L60.3995 12.0439Z",
						fill: "black",
						fillOpacity: .24
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M59.6584 14.1007L61.8906 46.0227L61.4415 46.0541L59.2093 14.1321L59.6584 14.1007ZM60.1571 14.0658L62.3893 45.9878L62.0406 46.0122L59.8084 14.0902L60.1571 14.0658ZM60.5566 14.0379L62.7888 45.9599L62.4887 45.9809L60.2565 14.0588L60.5566 14.0379ZM63.4366 45.9146L62.9378 45.9495L60.7056 14.0274L61.2044 13.9926L63.4366 45.9146Z",
						fill: "black",
						fillOpacity: .12
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35 6V6.2002H20V6H35ZM52.2041 6.01074C53.2128 6.11301 54 6.96435 54 8V44L53.9893 44.2041C53.8938 45.1457 53.1457 45.8938 52.2041 45.9893L52 46H4L3.7959 45.9893C2.85435 45.8938 2.1062 45.1457 2.01074 44.2041L2 44V8C2 6.96435 2.78722 6.113 3.7959 6.01074L4 6H19V6.2002H4C3.00589 6.2002 2.2002 7.00589 2.2002 8V44C2.2002 44.9941 3.00589 45.7998 4 45.7998H52C52.9941 45.7998 53.7998 44.9941 53.7998 44V8C53.7998 7.00589 52.9941 6.2002 52 6.2002H36V6H52L52.2041 6.01074Z",
				fill: "black",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.2246 44.165C54.2386 45.3108 53.3109 46.2458 52.165 46.2402L4 46H24.0527L52.165 46.1396C53.2552 46.1451 54.1385 45.2561 54.125 44.166L54 34.0361V30L54.0498 29.999L54.2246 44.165Z",
				fill: "black",
				fillOpacity: .12
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3846_330",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 48,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_3846_330",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 2,
			height: 37,
			fill: "white",
			transform: "translate(59 11.1394) rotate(-4)"
		})
	})] })]
});
export default SvgClipboardPencilLight;
